import { UserProfileTabId } from '../../User'

import {
  INHABITANT_PROFILE_TAB_LIST,
  STAFF_PROFILE_TAB_LIST,
} from './UserProfilePageTabs.constants'

export function getUserProfilePageTabList({ userData, onClickAddEmail }) {
  const tabs = userData?.isStaff
    ? STAFF_PROFILE_TAB_LIST
    : INHABITANT_PROFILE_TAB_LIST

  return tabs.map(tab =>
    tab.id === UserProfileTabId.Emails
      ? { ...tab, contentProps: { ...tab.contentProps, onClickAddEmail } }
      : tab
  )
}
